"use client";

import { useEffect, useState } from "react";

const MOBILE_UA_REGEX =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export function useDeviceDetection() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // 检测 User Agent
    const userAgent = navigator.userAgent;
    const isMobileDevice = MOBILE_UA_REGEX.test(userAgent);
    setIsMobile(isMobileDevice);
  }, []);

  return { isMobile };
}
